import React, { useEffect, useRef } from 'react'
import './mobile.scss'
import mobileShade from '../../../../src/assets/images/mobile_shade.png';
import mobTop from '../../../../src/assets/images/mob_top.png'

const Mobile = ({ children, logoUrl, action, previewTab }) => {

  let scrollAbleContent = useRef();

  useEffect(() => {

    console.log('previewTab' , previewTab)
    // Scroll to a specific position inside the scrollable container
    if (scrollAbleContent.current && previewTab) {
      let s_height = scrollAbleContent.current.scrollHeight; 
      if ( previewTab === 'dashboard' && s_height !== 0) {
        scrollAbleContent.current.scrollTo({
          top: s_height,
          behavior: "smooth",
        });
      }
      else {
        scrollAbleContent.current.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }
  },[children]);

  return (
    <div className='mobile_layout'>
      <div className="mob">
        <span className='mob_top'>
          <img className="img_full contain" src={mobTop} alt="" />
        </span>
        <div className="content demo_content" ref={scrollAbleContent}>
          {
            children
          }
        </div>
        <figure className='shade'>
          <img className='' src={mobileShade} alt="" />
        </figure>
      </div>
    </div>
  )
}

export default Mobile